module.exports = __webpack_public_path__ + "static/media/ellipse2.d3aca3fa.svg";